export default "__VITE_ASSET__CDSK4rzM__"